import { ResearcherRequest } from './../../../models/researcher-request';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  getRequests(): Observable<ResearcherRequest[]> {
    return this.apiService.get<ResearcherRequest[]>('/dashboard/requests');
  }

  acceptRequest(requestId: number, studyId: number): Observable<JSON> {
    return this.apiService.put<JSON>(`/dashboard/requests_accept_reject/${requestId}`, { accept: true, sid: studyId });
  }

  rejectRequest(requestId: number, studyId: number): Observable<JSON> {
    return this.apiService.put<JSON>(`/dashboard/requests_accept_reject/${requestId}`, { accept: false, sid: studyId });
  }

  constructor(private apiService: ApiService) {}
}
